import { CSSObject } from "styled-components";
import { vfxTheme } from "../common/VFX-UI/Theme/theme";

interface ButtonStyles {
    completeButton: CSSObject;
    searchCampaignContainer: CSSObject;
    completedButtonContainer: CSSObject;
    sectionHeader: CSSObject;
}

const useCampaignStyles = (): ButtonStyles => {
    
    return {
        completeButton: {
            backgroundColor: vfxTheme.palette.blueGreys.bg500,
            color: vfxTheme.palette.background.default,
            marginLeft: vfxTheme.spaceUnits.sp02,
            display: "flex",
            alignItems: "center",
            fontSize: "1rem",
        },
        searchCampaignContainer: {
            display: "flex",
            justifyContent: "space-evenly",
        },
        completedButtonContainer: {
            display: "flex",
            paddingLeft: "5px"
        },
        sectionHeader: {
            fontFamily: vfxTheme.typography.fontFamily,
            color: vfxTheme.palette.text.secondary,
            fontSize: "1.em",
            textTransform: "none",
            marginBottom: 0
        },
    };
};

export default useCampaignStyles;
